/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Home_Card_TitleInputs */

const en_dr_home_card_title = /** @type {(inputs: Dr_Home_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start from a Design Room`)
};

const id_dr_home_card_title = /** @type {(inputs: Dr_Home_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai dari Design Room`)
};

/**
* | output |
* | --- |
* | "Start from a Design Room" |
*
* @param {Dr_Home_Card_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_home_card_title = /** @type {((inputs?: Dr_Home_Card_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Home_Card_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_home_card_title(inputs)
	return en_dr_home_card_title(inputs)
});